const imgUrlConfig = {
    //for avatar
    avatar_logo: require('../assets/images/avatar_logo.png'),
    avatar_mini_logo: require('../../static/images/avatar_logo.png'),
    icon_number_avatar: require('../assets/images/icon_number_avatar.png'),
    // for conasi
    conasi_mini_logo: require('../../static/images/logo_conasi_mini.png'),
    conasi_logo: require('../assets/images/conasi_logo_1.png'),
    // for apollo
    apollo_mini_logo: require('../../static/images/logo_apollo_mini.png'),
    apollo_logo: require('../assets/images/apollo_logo.png'),
    // img_republic_logo: require('../assets/images/republic_logo.png'),
    // img_ariyana_logo: require('../assets/images/ariyana_logo.png'),
    // all
    img_checked: require('../assets/images/checked.png'),
    img_close: require('../assets/images/close.png'),
    img_no_permission: require('../assets/images/no_permission.png'),
    img_default_project: require('../assets/images/default_project_logo.png'),
    img_other_profile: require('../assets/images/orther_profile.png'),
    img_other_no_picture_available: require('../assets/images/no-picture-available-icon.jpg'),
    no_img_avatar: require('../assets/images/avatar.jpg'),
    noAvatarDefault: require('../assets/images/avatar-default.png'),
    backgroundPattern: require('../assets/images/bk-pattern.svg')
};
export default { imgUrlConfig };



// WEBPACK FOOTER //
// ./src/lib/config.js